// extracted by mini-css-extract-plugin
module.exports = {"categoryPage":"DeprecatedCategoryPage_categoryPage__fN0eX","divider":"DeprecatedCategoryPage_divider__0m5oa"};